import React, {useState} from "react";
import {Box, Dialog} from "@mui/material";

import {PhoneInput} from "../../../../designSystem/components/PhoneInput";
import {Dropdown} from "../../../../designSystem/components/Dropdown";
import {CheckButton} from "../../../../designSystem/components/CheckButton";
import {DateInput} from "../../../../designSystem/components/DateInput";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

import {ShortAnswer} from "../../../../components/ShortAnswer";
import {LongAnswer} from "../../../../components/LongAnswer";
import {CustomDialog} from "../../../../components/DialogCustom";

import {GENDER_OPTIONS, REGION_OPTIONS} from "../../../../utils/constants";
const REGIONS = REGION_OPTIONS.map(r => r.value).filter(r => r !== '不限').map(r => `屏東縣${r}`)

const clippedNumber = (value: string) => {
  const numericValue = value.replace(/\D/g, '');
  return numericValue.slice(0, 8);
}

export const NewApplicationForm = ({
  applicantName,
  applicantOrganization,
  applicantTitle,
  applicantPhone,
  applicantPhonePrefix,
  patientName,
  patientGender,
  patientId,
  patientHasTube,
  region,
  addressPart,
  yearRoc,
  month,
  day,
  primaryCaregiverName,
  relationshipWithPatient,
  currentHomeCareService,
  contactNumber,
  contactNumberPrefix,
  description,
  onChangeApplicantName,
  onChangeApplicantOrganization,
  onChangeApplicantTitle,
  onChangeApplicantPhone,
  onChangeApplicantPhonePrefix,
  onChangePatientName,
  onChangePatientGender,
  onChangePatientId,
  onChangePatientHasTube,
  onChangeRegion,
  onChangeAddressPart,
  onChangeYearRoc,
  onChangeMonth,
  onChangeDay,
  onChangePrimaryCaregiverName,
  onChangeRelationshipWithPatient,
  onChangeCurrentHomeCareService,
  onChangeContactNumber,
  onChangeContactNumberPrefix,
  onChangeDescription,
}) => {
  const [fieldValue, setFieldValue] = useState('');
  const [updatingField, setUpdatingField] = useState('');

  const handleSubmit = () => {
    if (updatingField === 'currentHomeCareService') {
      onChangeCurrentHomeCareService({
        ...currentHomeCareService,
        ...{'其他': fieldValue, '無': false},
      })
    } else if (updatingField === 'patientHasTube') {
      onChangePatientHasTube({
        ...patientHasTube,
        ...{'其他': fieldValue, '無': false},
      })
    }
    setUpdatingField('');
    setFieldValue('');
  }

  return (
    <div className="flex flex-col gap-4 p-6 ">
      <div className="grid grid-cols-2 gap-4">
        <ShortAnswer
          type="text"
          label="*申請人姓名："
          value={applicantName}
          onChange={(e) => onChangeApplicantName(e.target.value)}
        />
        <ShortAnswer
          type="text"
          label="*申請人服務單位："
          value={applicantOrganization}
          onChange={(e) => onChangeApplicantOrganization(e.target.value)}
        />
      </div>
      <div className="grid grid-cols-1 gap-4">
        <ShortAnswer
          type="text"
          label="*申請人職稱："
          value={applicantTitle}
          onChange={(e) => onChangeApplicantTitle(e.target.value)}
        />
      </div>
      <div className="grid grid-cols-1 gap-4">
        <p className={"page-title text-xl"}>*申請人聯繫電話：</p>
        <PhoneInput
          phone={applicantPhone}
          prefix={applicantPhonePrefix}
          onChangePrefix={(value) => onChangeApplicantPhonePrefix(value)}
          onChangePhone={(value) => {
            onChangeApplicantPhone(clippedNumber(value));
          }}
        />
      </div>

      <hr/>

      <div className="grid grid-cols-2 gap-4">
        <ShortAnswer
          type="text"
          label="*個案姓名："
          value={patientName}
          onChange={(e) => onChangePatientName(e.target.value)}
        />
        <div>
          <Box flex={1} className="page-title text-xl">*性別:</Box>
          <Box height={10}/>
          <Dropdown
            className={""}
            hasDiv={false}
            options={GENDER_OPTIONS.map(g => g.value)}
            dataSelected={patientGender}
            disabled={false}
            onChange={e => onChangePatientGender(e.target.value)}
            text="性別"
          />
        </div>
      </div>
      <div className="flex flex-col gap-y-2">
        <Box flex={1} className="page-title text-xl">*身體是否有管路:</Box>
        <div className="flex flex-row flex-wrap">
          {Object.keys(patientHasTube).map(pht => {
            const value = patientHasTube[pht]
            return (
              <CheckButton
                key={pht}
                selected={!(value === false || value === '')}
                label={`${pht}${typeof value === 'string' && value ? ': ' + value : ''}`}
                onClick={() => {
                  if (pht === '無') {
                    onChangePatientHasTube({
                      '無': !value,
                      '鼻胃管': false,
                      '尿管': false,
                      '氣切': false,
                      '廔管': false,
                      '引流管': false,
                      '其他': '',
                    })
                  } else if (pht === '其他') {
                    setUpdatingField('patientHasTube')
                  } else {
                    onChangePatientHasTube({
                      ...patientHasTube,
                      ...{'無': false},
                      [pht]: !value
                    })}
                }
                }
              />
            )
          })}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <ShortAnswer
          type="text"
          label="*身分證："
          value={patientId}
          onChange={(e) => onChangePatientId(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 gap-4">
        <p className={"page-title text-xl"}>*個案住址：</p>
        <Box>
          <Box className={"flex justify-start items-center gap-4"}>
            <Dropdown
              className={"flex flex-1"}
              hasDiv={false}
              options={REGIONS}
              dataSelected={region}
              disabled={false}
              onChange={e => onChangeRegion(e.target.value)}
              text=""
            />
            <ShortAnswer
              className="flex flex-1"
              label=""
              value={addressPart}
              onChange={e => onChangeAddressPart(e.target.value)}
            />
          </Box>
        </Box>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <Box>
          <p className={"page-title text-xl mb-2"}>*個案出生年月日：</p>
          <DateInput
            yearRoc={yearRoc}
            month={month}
            day={day}
            onChangeYearRoc={onChangeYearRoc}
            onChangeMonth={onChangeMonth}
            onChangeDay={onChangeDay}
          />
        </Box>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <ShortAnswer
          type="text"
          label="*主要照顧者姓名："
          value={primaryCaregiverName}
          onChange={(e) => onChangePrimaryCaregiverName(e.target.value)}
        />
        <ShortAnswer
          type="text"
          label="*與個案關係："
          value={relationshipWithPatient}
          onChange={(e) => onChangeRelationshipWithPatient(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 gap-4">
        <Box flex={1} className="page-title text-xl">*目前接受在宅照服項目:</Box>
        <div className="flex flex-row flex-wrap">
          {Object.keys(currentHomeCareService).map(service => {
            const value = currentHomeCareService[service]
            return (
              <CheckButton
                key={service}
                selected={!(value === false || value === '')}
                label={`${service}${typeof value === 'string' && value ? ': ' + value : ''}`}
                onClick={() => {
                  if (service === '無') {
                    onChangeCurrentHomeCareService({
                      '無': !value,
                      '居家醫療': false,
                      '居家護理': false,
                      '居家服務': false,
                      '其他': '',
                    })
                  } else if (service === '其他') {
                    setUpdatingField('currentHomeCareService')
                  } else {
                    onChangeCurrentHomeCareService({
                      ...currentHomeCareService,
                      ...{'無': false},
                      [service]: !value
                    })
                  }
                }
                }
              />
            )
          })}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <p className={"page-title text-xl"}>*個案/家屬電話：</p>
        <PhoneInput
          phone={contactNumber}
          prefix={contactNumberPrefix}
          onChangePrefix={(value) => onChangeContactNumberPrefix(value)}
          onChangePhone={(value) => {
            onChangeContactNumber(clippedNumber(value));
          }}
        />
      </div>
      <LongAnswer
        label="*個案現況簡述 (個案疾病、症狀、目前醫療狀況、就醫院所、目前狀況...等)"
        value={description}
        onChange={(e) => onChangeDescription(e.target.value)}
      />

      <Dialog
        open={updatingField !== ''}
        PaperProps={{
          sx: { borderRadius: 6 },
        }}
      >
        <CustomDialog>
          <p className={"page-title"}>其他：</p>
          <ShortAnswer
            className="flex flex-1"
            label=""
            value={fieldValue}
            onChange={e => setFieldValue(e.target.value)}
          />
          <ActionButton
            label="填好了"
            onClick={handleSubmit}
            disabled={!fieldValue}
            fullWidth
          />
        </CustomDialog>
      </Dialog>
    </div>
  )
}